import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import NiceSelect from '../Header/NiceSelect';
import Modal from 'react-modal';
import axios from "axios";
import { apiUrl } from '../../Constants/contant';
import { toast } from 'react-toastify';

Modal.setAppElement('#root');
function BookATour() {
    const [modalIsOpen, setModalIsOpen] = useState(false);
      const [countryOptions, setCountryOptions] = useState([]);

const [loading, setLoading] = useState(false);

const [formData, setFormData] = useState({
  name: "",
  phone: "",
  tour_type: "",
  message: "",
});


useEffect(() => {
    fetch(apiUrl + "front")
      .then((response) => response.json())
      .then((data) => {
        const catData = data.category || [];

        // ✅ Convert categories into dropdown options
        const options = catData.map((item) => ({
          value: item.id,
          label: item.title,
        }));

        // Optionally add default first option
        setCountryOptions([
          { value: "country", label: "Select Tour Type" },
          ...options,
        ]);
      })
      .catch((error) => {
        console.error("There was an error fetching categories!", error);
      });
  }, []);



   const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        };

 

    // Submit Handler
const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    setLoading(true);

    const response = await axios.post(
      apiUrl + "book-tour",
      formData,
    );

    if (response.data) {
      toast.success("Tour enquiry submitted successfully!");

      setFormData({
        name: "",
        phone: "",
        tour_type: "",
        message: "",
      });
    }
  } catch (error) {
    console.error(error);

    toast.error(
      error?.response?.data?.message ||
        "Something went wrong. Please try again."
    );
  } finally {
    setLoading(false);
  }
};


    return (
        <div
            className="space-extra2-top space-extra2-bottom"
            style={{ background: "url(/assets/img/normal/about2.jpg)", backgroundRepeat: "no-repeat", backgroundSize: "cover" }}
        >
            <div className="container">
                <div className="row flex-row-reverse justify-content-center align-items-center">
                    <div className="col-lg-6">
                        <div className="video-box1">
                            <button className="play-btn style2 popup-video" onClick={() => setModalIsOpen(true)}>
                                <i className="fa-sharp fa-solid fa-play" />
                            </button>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div>
                            <form className="contact-form style2 ajax-contact" onSubmit={handleSubmit}>
                                <h3 className="sec-title mb-30 text-capitalize">Book a tour</h3>

                                <div className="row">
                                    <div className="col-12 form-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="name"
                                            value={formData.name} onChange={handleChange}
                                            id="name3"
                                            placeholder="First Name"
                                            required
                                        />
                                        <img src="assets/img/icon/user.svg" alt="" />
                                    </div>
                                    {/* <div className="col-12 form-group">
                                        <input
                                            type="email"
                                            value={formData.email} onChange={handleChange}
                                            className="form-control"
                                            name="email"
                                            id="email3"
                                            placeholder="Your Mail"
                                            required
                                        />
                                        <img src="assets/img/icon/mail.svg" alt="" />
                                    </div> */}
                                      <div className="col-12 form-group">
                                      <input
                                        type="tel"
                                        className="form-control"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        placeholder="Your Phone"
                                        required
                                        />
                                        <img src="assets/img/icon/phone.svg" alt="" />
                                    </div>
                                    <div className="form-group col-12">
  <select
    className="form-control"
    name="tour_type"
    value={formData.tour_type}
    onChange={handleChange}
    required
  >

    {countryOptions.map((item) => (
      <option key={item.value} value={item.value}>
        {item.label}
      </option>
    ))}
  </select>


                                    </div>
                                    <div className="form-group col-12">
                                        <textarea
                                            name="message"
                                            id="message"
                                            value={formData.message} onChange={handleChange}
                                            cols={30}
                                            rows={3}
                                            className="form-control"
                                            placeholder="Your Message"
                                            defaultValue={""}
                                        />
                                        <img src="assets/img/icon/chat.svg" alt="" />
                                    </div>
                                    <div className="form-btn col-12 mt-24">
                                       <button
                                            type="submit"
                                            className="th-btn style3"
                                            disabled={loading}
                                            >
                                            {loading ? "Submitting..." : "Send Message"}

                                            <img src="assets/img/icon/plane.svg" alt="" />
                                            </button>
                                    </div>
                                </div>
                                <p className="form-messages mb-0 mt-3" />

                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={() => setModalIsOpen(false)}
                contentLabel="Video Popup"
                className="video-modal"
                overlayClassName="video-modal-overlay"
            >
                <button className="close-btn" onClick={() => setModalIsOpen(false)}>&times;</button>
                <iframe
                    width="100%"
                    height="400px"
    src="https://www.youtube.com/embed/8Y53393Hf8k"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                ></iframe>
            </Modal>
        </div>
    )
}

export default BookATour
